import { render, staticRenderFns } from "./TermAndPolicy.vue?vue&type=template&id=1c0e037c&scoped=true&"
import script from "./TermAndPolicy.vue?vue&type=script&lang=js&"
export * from "./TermAndPolicy.vue?vue&type=script&lang=js&"
import style0 from "./TermAndPolicy.vue?vue&type=style&index=0&id=1c0e037c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e037c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VDialog,VIcon,VSpacer})
